/**************************************************
 * Nombre:       Seccion_Formacion_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Formacion_Portada from "./Componentes/Formacion_Portada";
import Formacion_Resolucion_Informacion from "./Componentes/Formacion_Resolucion_Informacion";
import fondo from '../../Recursos/fondo_formacion.svg'
import Formacion_PorQue from "./Componentes/Formacion_PorQue";
import Formacion_Razones from "./Componentes/SucComponentes/Formacion_Razones";
import Formacion_Perfil_Ocupacional from "./Componentes/Formacion_Perfil_Ocupacional";
import Formacion_Plan_Estudios from "./Componentes/Formacion_Plan_Estudios";
import {useEffect} from "react";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {irArriba} from "../../Utilidades/irArriba";


const Seccion_Formacion_Detalle = () => {
    const {sCell} = useResponsive()

    useEffect(() => {
        irArriba()
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? -1 : 0}}>
                <Formacion_Portada/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${fondo})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center right',
                }}

            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 12}}>
                    <Formacion_Resolucion_Informacion/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 12}}>
                    <Formacion_PorQue/>
                </Grid>


            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 12 : 18}}>
                <Formacion_Razones/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 14 : 20, overflowX: 'hidden'}}>
                <Formacion_Perfil_Ocupacional/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 18}}>
                <Formacion_Plan_Estudios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 20}}>
                <Home_Testimonios/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Formacion_Detalle